import React from 'react';

import ListPrice from '../list-price';
import AlertPrice from '../alert-price';
import QuantityControls from '../edit-control/quantity';

import { ItemWithProduct } from '../sharedTypes';

import * as S from './styles';

type ProductRowProps = {
  item: ItemWithProduct;
  updateQuantity?: (id: number, quantity: number) => void;
};

const ProductRow = (props: ProductRowProps) => {
  const { item, updateQuantity } = props;
  const rating = item.product && item.product.userReviewSummary.rating;

  const renderPrice = () => {
    switch (item.__typename) {
      case 'AlertProduct':
        return (
          <AlertPrice
            price={item.product.priceSummary}
            latestPriceChange={item.product.latestPriceChange}
          />
        );
      case 'ListProduct':
        return (
          (item.product.priceSummary.regular ||
            item.product.priceSummary.alternative) && (
            <ListPrice
              price={
                item.product.priceSummary.regular ||
                item.product.priceSummary.alternative
              }
              quantity={item.quantity}
            />
          )
        );

      default:
        return null;
    }
  };

  return (
    <S.ProductRow>
      {item.product.media.first && (
        <S.ProductImage
          name={item.product.name}
          src={item.product.media.first}
        />
      )}

      <S.Info>
        <S.Name>{item.product.name}</S.Name>

        {item.product.category && (
          <S.Subtitle>{item.product.category.name}</S.Subtitle>
        )}

        <S.BottomRow row={item.__typename === 'ListProduct'}>
          {rating && (
            <S.Rating
              hide={rating === null}
              rate={rating}
              showRate
              size="small"
              singleStar={item.__typename === 'ListProduct'}
            />
          )}

          <S.PriceRow>
            <S.Price type={item.__typename} rating={Boolean(rating)}>
              {renderPrice()}
            </S.Price>

            {updateQuantity && (
              <QuantityControls item={item} updateQuantity={updateQuantity} />
            )}
          </S.PriceRow>
        </S.BottomRow>
      </S.Info>
    </S.ProductRow>
  );
};

ProductRow.defaultProps = {
  canEdit: false,
};

export default ProductRow;
